export default "__VITE_ASSET__BCFMvaWL__"